import { Component } from '@angular/core';
import { COMPANY_DATA } from '../../data/company.data';
@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  company = COMPANY_DATA.company;
  footerColumns = COMPANY_DATA.footer.columns;
  socialLinks = COMPANY_DATA.socialLinks;
  currentYear = new Date().getFullYear();
}
